/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Flow_LabelInputs */

const en_services_flow_label = /** @type {(inputs: Services_Flow_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustrative system: your sources feed Lindevo, which prepares work for review`)
};

const lv_services_flow_label = /** @type {(inputs: Services_Flow_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piemērs: Jūsu avoti nonāk Lindevo sistēmā, kas sagatavo darbu pārskatīšanai`)
};

/**
* | output |
* | --- |
* | "Illustrative system: your sources feed Lindevo, which prepares work for review" |
*
* @param {Services_Flow_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_flow_label = /** @type {((inputs?: Services_Flow_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Flow_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_flow_label(inputs)
	return en_services_flow_label(inputs)
});